// extracted by mini-css-extract-plugin
export var actionButton = "_xb-2";
export var card = "_xb-0";
export var errorCard = "_xb-1";